import { render, staticRenderFns } from "./roomPay.vue?vue&type=template&id=b15c8a88&scoped=true"
import script from "./roomPay.vue?vue&type=script&lang=js"
export * from "./roomPay.vue?vue&type=script&lang=js"
import style0 from "./roomPay.vue?vue&type=style&index=0&id=b15c8a88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15c8a88",
  null
  
)

export default component.exports